import React from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';

const grid = [
    ['', '', '', '', 'bg-[#4339F2]', ''],
    ['', '', '', 'bg-[#4339F2]', 'bg-[#4339F2]', ''],
    ['', '', 'bg-[#4339F2]', '', 'bg-[#4339F2]', ''],
    ['', 'bg-[#4339F2]', '', '', 'bg-[#4339F2]', ''],
    ['bg-[#4339F2]', '', '', '', 'bg-[#4339F2]', ''],
    [
        'bg-[#4339F2]',
        'bg-[#4339F2]',
        'bg-[#4339F2]',
        'bg-[#4339F2]',
        'bg-[#4339F2]',
        'bg-[#4339F2]',
    ],
    ['', '', '', '', 'bg-[#4339F2]', ''],
    ['', '', '', '', 'bg-[#4339F2]', ''],
];

const getRandomAnimation = () => ({
    initial: { opacity: 0, scale: 0.3 },
    animate: {
        opacity: 1,
        scale: 1,
    },
    transition: {
        duration: 0.3,
        delay: 0.5 + Math.random() * 1.5,
        ease: 'easeOut',
    },
});

type NumProps = {
    className?: string;
};

const Four = ({ className }: NumProps) => (
    <div className={clsx('flex flex-col', className)}>
        {grid.map((row, rowIndex) => (
            <div key={rowIndex} className='flex'>
                {row.map((color, colIndex) => (
                    <motion.div
                        key={`${color}-${colIndex}`}
                        className={`w-[44px] h-[44px] transition-all duration-300 ease-out ${color ? `${color}` : ''}`}
                        {...getRandomAnimation()}
                    />
                ))}
            </div>
        ))}
    </div>
);

export default Four;
